import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { Layout } from "@/components/Layout";
import { loadAdsense } from "@/lib/adsense";
import HomePage from "@/pages/HomePage";
import CalculatorsHub from "@/pages/CalculatorsHub";
import TaxBracketCalculator from "@/pages/calculators/TaxBracketCalculator";
import StandardDeductionCalculator from "@/pages/calculators/StandardDeductionCalculator";
import ChildTaxCreditCalculator from "@/pages/calculators/ChildTaxCreditCalculator";
import CapitalGainsCalculator from "@/pages/calculators/CapitalGainsCalculator";
import SALTDeductionCalculator from "@/pages/calculators/SALTDeductionCalculator";
import QBICalculator from "@/pages/calculators/QBICalculator";
import EstateTaxCalculator from "@/pages/calculators/EstateTaxCalculator";
import TipsCalculator from "@/pages/calculators/TipsCalculator";
import OvertimeCalculator from "@/pages/calculators/OvertimeCalculator";
import SeniorDeductionCalculator from "@/pages/calculators/SeniorDeductionCalculator";
import AutoLoanInterestCalculator from "@/pages/calculators/AutoLoanInterestCalculator";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import StatesHub from "@/pages/StatesHub";
import StateIncomeTaxPage from "@/pages/StateIncomeTaxPage";
import AboutPage from "@/pages/AboutPage";
import EditorialPage from "@/pages/EditorialPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicy from "@/pages/compliance/PrivacyPolicy";
import TermsOfService from "@/pages/compliance/TermsOfService";
import CookiePolicy from "@/pages/compliance/CookiePolicy";
import GDPR from "@/pages/compliance/GDPR";
import Disclaimer from "@/pages/compliance/Disclaimer";
import NotFound from "@/pages/NotFound";

function App() {
  // Eagerly inject Google AdSense script on every page so Google can verify
  // ownership during review and serve ads once approved. No-op when
  // REACT_APP_ADSENSE_CLIENT is not configured (preview / dev).
  useEffect(() => {
    loadAdsense();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/calculators" element={<CalculatorsHub />} />
            <Route path="/calculator/tax-bracket-2026" element={<TaxBracketCalculator />} />
            <Route path="/calculator/standard-deduction-2026" element={<StandardDeductionCalculator />} />
            <Route path="/calculator/child-tax-credit-2026" element={<ChildTaxCreditCalculator />} />
            <Route path="/calculator/capital-gains-2026" element={<CapitalGainsCalculator />} />
            <Route path="/calculator/salt-deduction-2026" element={<SALTDeductionCalculator />} />
            <Route path="/calculator/qbi-deduction-2026" element={<QBICalculator />} />
            <Route path="/calculator/estate-tax-2026" element={<EstateTaxCalculator />} />
            <Route path="/calculator/no-tax-on-tips" element={<TipsCalculator />} />
            <Route path="/calculator/no-tax-on-overtime" element={<OvertimeCalculator />} />
            <Route path="/calculator/senior-deduction-2026" element={<SeniorDeductionCalculator />} />
            <Route path="/calculator/auto-loan-interest-2026" element={<AutoLoanInterestCalculator />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/states" element={<StatesHub />} />
            <Route path="/calculators/state-income-tax/:state" element={<StateIncomeTaxPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/editorial" element={<EditorialPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/gdpr" element={<GDPR />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
